import { NavLink } from "react-router-dom";
import { useState } from "react";
import {
  LayoutDashboard,
  ShieldCheck,
  Users,
  Package,
  UserRound,
  Truck,
  ShoppingCart,
  ReceiptText,
  BarChart3,
  FileText,
  Boxes,
  Sparkles,
  ChevronDown,
  Database,
  WalletCards,
  Building2,
  Printer,
} from "lucide-react";

function Sidebar({ onNavigate = () => {} }) {
  const [openMenu, setOpenMenu] = useState({
    transactions: true,
    accounts: false,
    master: false,
    reports: false,
  });

  const toggleMenu = (key) => {
    setOpenMenu((prev) => ({
      transactions: false,
      accounts: false,
      master: false,
      reports: false,
      [key]: !prev[key],
    }));
  };

  const handleNavigate = () => {
    onNavigate();
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-logo">
          <Sparkles size={22} />
        </div>

        <div>
          <h2>E-Billing</h2>
          <p>Modern Retail Suite</p>
        </div>
      </div>

      <nav className="sidebar-menu">
        <NavLink
          to="/dashboard"
          onClick={handleNavigate}
          className={({ isActive }) =>
            isActive
              ? "sidebar-link active"
              : "sidebar-link"
          }
        >
          <span className="sidebar-icon">
            <LayoutDashboard />
          </span>

          <span>Dashboard</span>
        </NavLink>

        <SidebarGroup
          title="Transactions"
          icon={<WalletCards />}
          open={openMenu.transactions}
          onClick={() => toggleMenu("transactions")}
        >
          <SidebarItem
            path="/transaction/sale"
            icon={<ReceiptText />}
            name="Sale Billing"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/transaction/purchase"
            icon={<ShoppingCart />}
            name="Purchase"
            onNavigate={handleNavigate}
          />
        </SidebarGroup>

        <SidebarGroup
          title="Accounts"
          icon={<Users />}
          open={openMenu.accounts}
          onClick={() => toggleMenu("accounts")}
        >
          <SidebarItem
            path="/accounts/customer"
            icon={<UserRound />}
            name="Customer"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/accounts/supplier"
            icon={<Truck />}
            name="Supplier"
            onNavigate={handleNavigate}
          />
        </SidebarGroup>

        <SidebarGroup
          title="Master"
          icon={<Database />}
          open={openMenu.master}
          onClick={() => toggleMenu("master")}
        >
          <SidebarItem
            path="/master/firm"
            icon={<Building2 />}
            name="Firm"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/master/print-settings"
            icon={<Printer />}
            name="Print Settings"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/master/product"
            icon={<Package />}
            name="Product"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/master/users"
            icon={<Users />}
            name="Users"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/master/roles"
            icon={<ShieldCheck />}
            name="Roles"
            onNavigate={handleNavigate}
          />
        </SidebarGroup>

        <SidebarGroup
          title="Reports"
          icon={<BarChart3 />}
          open={openMenu.reports}
          onClick={() => toggleMenu("reports")}
        >
          <SidebarItem
            path="/reports/stock"
            icon={<Boxes />}
            name="Stock Report"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/reports/sale"
            icon={<BarChart3 />}
            name="Sale Report"
            onNavigate={handleNavigate}
          />

          <SidebarItem
            path="/reports/purchase"
            icon={<FileText />}
            name="Purchase Report"
            onNavigate={handleNavigate}
          />
        </SidebarGroup>
      </nav>
    </aside>
  );
}

function SidebarGroup({
  title,
  icon,
  open,
  onClick,
  children,
}) {
  return (
    <div className="sidebar-dropdown">
      <button
        type="button"
        className={
          open
            ? "sidebar-dropdown-btn open"
            : "sidebar-dropdown-btn"
        }
        onClick={onClick}
      >
        <span className="sidebar-icon">
          {icon}
        </span>

        <span>{title}</span>

        <ChevronDown className="dropdown-arrow" />
      </button>

      {open && (
        <div className="sidebar-dropdown-list">
          {children}
        </div>
      )}
    </div>
  );
}

function SidebarItem({
  path,
  icon,
  name,
  onNavigate,
}) {
  return (
    <NavLink
      to={path}
      onClick={onNavigate}
      className={({ isActive }) =>
        isActive
          ? "sidebar-sub-link active"
          : "sidebar-sub-link"
      }
    >
      <span className="sidebar-sub-icon">
        {icon}
      </span>

      <span>{name}</span>
    </NavLink>
  );
}

export default Sidebar;